import BaseModel from '../BaseModel';

export default class OfficeInterviewImage extends BaseModel {
  static entity = 'officeInterviewImages';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      interviewId: this.attr(null),
      type: this.string(null).nullable(),
      url: this.string(null).nullable(),
    };
  }
}
